module.exports = __webpack_public_path__ + "img/slide3.77d96426.png";